import React, {Component} from 'react';
import {SubCriterionParameter} from "../../domain/criterion/subCriterionParameterDomain";
import {RadioButton, RadioButtonGroup} from "material-ui";
import {SubCriterion} from "../../domain/criterion/subCriterionDomain";
import {observer} from "mobx-react";
import sbToolParamsService from "../../service/paramsService";
import {ProjectVersionParamValue} from "../../domain/project/projectVersionParameterValueDomain";
import SbToolProjectVersionService from "../../service/projectVersionService";
import {SubCriterionParameterValue} from "../../domain/criterion/subCriterionParameterValueDomain";


interface Props {
  subCriterion : SubCriterion
  handleChangeValueState: (bool:boolean)=>void

}

const PARAM_NUMBER : number = 1

@observer
class ParametersSelectForm extends Component<Props, undefined> {


  private onSelect = (e: React.FormEvent<{}>, selected: string, subCriterionParam : SubCriterionParameter) => {

    let value = subCriterionParam.parameters.find(p => p.valueId === Number(selected));
    let versionParam = sbToolParamsService.paramsValues.find(p => p.paramNumber === PARAM_NUMBER && p.parameter.paramId === subCriterionParam.paramId)
    if (versionParam) {
      versionParam.value = String(value.valueId);
    } else {
      let param = new ProjectVersionParamValue({
        value : String(value.valueId),
        paramNumber : PARAM_NUMBER,
        projectVersion : SbToolProjectVersionService.projectVersion,
        parameter : subCriterionParam,
        count : 1,
        $new : true
      })
      param.initAfterRead(true);
      sbToolParamsService.paramsValues.push(param);
    }
    this.props.handleChangeValueState(true)
  }

  private formatValue = (value : SubCriterionParameterValue)  => {
    let text =  value.label.trim() + " (" + value.value + ")"
    return (<div style={{whiteSpace: "pre-line", width : "100%"}}>{text}</div>)
  }

  private renderButtons = (subCriterionParam : SubCriterionParameter) => {
    return subCriterionParam.parameters
      .sort((p1, p2) => p1.value - p2.value)
      .map((param, index) => {
      return <RadioButton key={index} value={param.valueId} label={this.formatValue(param)}/>
    })
  }

  private renderButtonGroup = (subCriterionParam : SubCriterionParameter) => {
    let selectedValueId = undefined;
    let param = sbToolParamsService.paramsValues.find(p => p.parameter.paramId === subCriterionParam.paramId);
    if (param) {
      let selectedValue = subCriterionParam.parameters.find(p => p.valueId === Number(param.value));
      if (selectedValue) {
        selectedValueId = selectedValue.valueId;
      }
    }

    return (
      <div>
        {subCriterionParam.name}
        <RadioButtonGroup name={subCriterionParam.name}
                          valueSelected={selectedValueId}
                          onChange={(e, selected) => this.onSelect(e, selected, subCriterionParam)}
                          key={subCriterionParam.number}
        >
          {this.renderButtons(subCriterionParam)}
        </RadioButtonGroup>
      </div>
    )
  }

render() {
  return (
    <div style={{marginTop : 20, width : "100%"}}>
      {this.props.subCriterion.parameters.map(p => this.renderButtonGroup(p))}
    </div>
  )
}
}

export default ParametersSelectForm;






// WEBPACK FOOTER //
// ./src/sbtool/component/parameter/parametersSelectForm.tsx